// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","navContainer":"App_navContainer__32exR","routesContainer":"App_routesContainer__37m85"};